export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  // Fonte da verdade em shared/helpers/recentEmojis.js (o picker é compartilhado
  // com o widget e não pode importar do dashboard).
  RECENT_EMOJIS: 'recentEmojis',
};
